export interface Testimonial {
  pull: string;
  quote: string;
  name: string;
  role: string;
  initials: string;
}

export const testimonialsData: Testimonial[] = [
  {
    pull: "A perfect balance of compassion and candour.",
    quote: "Renée is an invaluable asset to any team. She delivers high-quality TypeScript and React code while bringing essential broader skills like refinement, project management, and team ceremonies. She provides clear articulation of problems and solutions, and always does it with a perfect balance of compassion and candour.",
    name: "Dan B.",
    role: "Engineering Manager",
    initials: "DB"
  },
  {
    pull: "Always considering the broader vision and user experience.",
    quote: "Renée stands out for her forward-thinking approach to software engineering. She goes beyond coding tasks, always considering the broader vision and user experience. Her proactive documentation of technical requirements has been instrumental in project success, providing the clarity and guidance needed for the entire team to succeed.",
    name: "Daniil V.",
    role: "Senior Product Designer",
    initials: "DV"
  },
  {
    pull: "Consistently delivered high-quality work.",
    quote: "Renée has consistently delivered high-quality work and plays a key role in fostering a documentation culture. She ensures technical processes and team procedures are well-documented for knowledge sharing, and her leadership in organizing team-wide initiatives demonstrates her ability to coordinate and lead effectively.",
    name: "Oluwadamilola A.",
    role: "Backend Engineer",
    initials: "OA"
  },
  {
    pull: "Make complex technical concepts accessible and relatable.",
    quote: "I highly recommend Renée for her exceptional ability to make complex technical concepts accessible and relatable. She excels at bridging the gap between personal narrative and technical insight, empowering stakeholders and listeners from all backgrounds to understand and align with technical goals.",
    name: "Max B.",
    role: "Talent",
    initials: "MB"
  },
  {
    pull: "Exceptionally detail-oriented and highly responsible.",
    quote: "Working with Renée is a great experience; she is exceptionally detail-oriented and highly responsible in delivering projects. Beyond her technical execution, she has shown the skills of a great leader—taking charge of organizational initiatives that drive collaboration and resourcefulness across the entire team.",
    name: "Carolina P.",
    role: "Senior Frontend Engineer",
    initials: "CP"
  }
];
